import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { localize } from 'react-localize-redux';

import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import MenuItem from 'material-ui/MenuItem';

import RenderDropzoneMultiFileInput from 'components/shared/RenderDropzoneMultiFileInput';
import SearchableSelectRedux from 'components/shared/SearchableSelectRedux';

import * as validator from 'helpers/Validator';

import { getTenantPortalRequestType } from 'helpers/SelectOptions';

import validate from 'components/tenant_application/validate';

let RequestMaintenanceFormIndustrial = props => {
  const { handleSubmit, rooms, translate, maintenanceCategories } = props;

  const FILE_FIELD_NAME = 'files';

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12">
          <Field
            name="category"
            component={OutlinedSelect}
            validate={[validator.required]}
            fullWidth
            autoWidth
            variant="outlined"
            label={translate('RFM.category')}
            style={{ fontSize: '14px' }}
          >
            {maintenanceCategories.map(category => (
              <MenuItem value={category.value} key={category.label} label={category.label}>
                {category.label}
              </MenuItem>
            ))}
          </Field>
        </div>
        <div className="col-xs-12" style={{ marginTop: '15px' }}>
          <Field
            fullWidth
            name="room"
            label={translate('RFM.room')}
            component={SearchableSelectRedux}
            options={rooms}
            validate={[validator.required]}
            variant="outlined"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12" style={{ marginTop: '15px' }}>
          <Field
            name="subject"
            validate={[validator.required]}
            component={TextField}
            fullWidth
            style={{ fontSize: '15px' }}
            variant="outlined"
            label={translate('RFM.subject')}
          />
        </div>
        <div className="col-xs-12" style={{ marginTop: '15px' }}>
          <Field
            name="priority"
            component={OutlinedSelect}
            validate={[validator.required]}
            fullWidth
            autoWidth
            variant="outlined"
            label={translate('RFM.priority')}
          >
            <MenuItem value={'Emergency'}> {translate('RFM.emergency')} </MenuItem>
            <MenuItem value={'High'}> {translate('RFM.high')} </MenuItem>
            <MenuItem value={'Normal'}> {translate('RFM.normal')} </MenuItem>
          </Field>
        </div>
        <div className="col-xs-12" style={{ marginTop: '15px' }}>
          <Field
            name="request_type"
            component={OutlinedSelect}
            validate={[validator.required]}
            fullWidth
            autoWidth
            variant="outlined"
            label={translate('RFM.request_type')}
          >
            {getTenantPortalRequestType().map(request_type => {
              return (
                <MenuItem value={request_type.value} key={translate(request_type.label)}>
                  {translate(request_type.label)}
                </MenuItem>
              );
            })}
          </Field>
        </div>
        <div className="col-xs-12" style={{ marginTop: '15px' }}>
          <Field
            name="ticket_description"
            component={TextField}
            validate={[validator.required]}
            label={translate('RFM.description')}
            multiLine={true}
            fullWidth
            rows={1}
            style={{ fontSize: '15px' }}
            variant="outlined"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12" style={{ marginTop: '15px' }}>
          <Field
            name="tenant_note"
            component={TextField}
            hintText={translate('portal.serviceRequestDescriptor.visibleToLandlord')}
            hintStyle={{ fontSize: '15px' }}
            rows={2}
            multiline
            fullWidth
            placeholder={translate('RFM.tenant_note').props.children}
            style={{
              marginTop: '2px',
              fontSize: '15px',
              marginBottom: '-3px',
            }}
            variant="outlined"
          />
        </div>
      </div>

      <div className="row" style={{ padding: '15px' }}>
        <Field
          name={FILE_FIELD_NAME}
          component={RenderDropzoneMultiFileInput}
          acceptedFileTypes="application/pdf, .jpeg, .png, .jpg"
        />
      </div>
    </form>
  );
};

export default compose(
  connect((state, ownProps) => ({
    form: ownProps.formName,
    maintenanceCategories: state.maintenanceReducer.maintenanceCategories,
  })),
  reduxForm({
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    validate,
  })
)(localize()(RequestMaintenanceFormIndustrial));
